import { apiSlice } from 'src/app/redux/api/apiSlice';
import { finalUrlsConfig } from 'src/configs/url.config';

export const learnerSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    learnInterest: builder.mutation<void, {}>({
      query: () => ({
        url: finalUrlsConfig().interest.learner,
        method: 'POST',
      }),
    }),
  }),
});

export const { useLearnInterestMutation } = learnerSlice;
